import { ImageCardProps } from '@backrs_ui/common-ui';

import { APP_ROUTE } from '@backrs_ui/grow-ui/src/App';
import { appStrings } from '@backrs_ui/grow-ui/src/assets/appStrings';
import { SEARCH_PAGE_CATEGORIES } from '@backrs_ui/grow-ui/src/pages/Search/search.types';

import { HomePageSection } from './useGetHomePageSections';

const EXPLORE_OPPORTUNITIES_STRINGS = appStrings.modules.home.sections.exploreOpportunities;

export const EXPLORE_OPPORTUNITIES_SECTION = ({ navigate }: HomePageSection): ImageCardProps[] => [
  {
    title: EXPLORE_OPPORTUNITIES_STRINGS.imageCards.exploreUniversities.title,
    description: EXPLORE_OPPORTUNITIES_STRINGS.imageCards.exploreUniversities.description,
    imageUrl: '/images/explore-universities.png',
    onClick: () => navigate(`${APP_ROUTE.SEARCH}/${SEARCH_PAGE_CATEGORIES.COLLEGES}`),
  },
  {
    title: EXPLORE_OPPORTUNITIES_STRINGS.imageCards.discoverJobsInternships.title,
    description: EXPLORE_OPPORTUNITIES_STRINGS.imageCards.discoverJobsInternships.description,
    imageUrl: '/images/explore-internships.png',
    onClick: () => navigate(`${APP_ROUTE.SEARCH}/${SEARCH_PAGE_CATEGORIES.INTERNSHIPS}`),
  },
  {
    title: EXPLORE_OPPORTUNITIES_STRINGS.imageCards.findScholarships.title,
    description: EXPLORE_OPPORTUNITIES_STRINGS.imageCards.findScholarships.description,
    imageUrl: '/images/explore-scholarships.png',
    onClick: () => navigate(`${APP_ROUTE.SEARCH}/${SEARCH_PAGE_CATEGORIES.SCHOLARSHIPS}`),
  },
];
